const config = {
  ChaveIntegracao: "X6IX78PLREJC4CIRNL7OVNHPX50PLZ",
  NewChaveIntegracao: "YOXB2Z3NVQROF7LSB0ELADG1Q98H60",
  urlApiTely: "https://us-central1-tely-totem.cloudfunctions.net/api"
}

export default config 
